var StorefrontAPI = StorefrontAPI || {};
StorefrontAPI.Query = async (query = '') =>  {
  const response = await fetch('https://idealcabinetry.myshopify.com/api/2024-07/graphql.json', {
      method: 'POST',
      mode: "cors",
      headers: {
          "X-Shopify-Storefront-Access-Token": '5717a2f95e342721e4e25fc123c35af1',
          'Content-Type': 'application/graphql'
      },
      body: query
  });
  return response.json();
};
